<template>
  <div class="mb-4">
    <ContractsList></ContractsList>
  </div>
</template>

<script>
import ContractsList from '@/components/Widgets/Contracts/ContractsList/ContractsList.vue';
export default {
  name: 'Contracts',
  components: {
    ContractsList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>